import { render, staticRenderFns } from "./temporizador.vue?vue&type=template&id=e38ccb54&scoped=true"
import script from "./temporizador.vue?vue&type=script&lang=js"
export * from "./temporizador.vue?vue&type=script&lang=js"
import style0 from "./temporizador.vue?vue&type=style&index=0&id=e38ccb54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e38ccb54",
  null
  
)

export default component.exports